import { render, staticRenderFns } from "./MyPositionPro.vue?vue&type=template&id=7f8fe651&scoped=true&"
import script from "./MyPositionPro.vue?vue&type=script&lang=js&"
export * from "./MyPositionPro.vue?vue&type=script&lang=js&"
import style0 from "./MyPositionPro.vue?vue&type=style&index=0&id=7f8fe651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8fe651",
  null
  
)

export default component.exports